import { render, staticRenderFns } from "./AddVideoToSchedule.vue?vue&type=template&id=2c4c695a&scoped=true&"
import script from "./AddVideoToSchedule.vue?vue&type=script&lang=js&"
export * from "./AddVideoToSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoToSchedule.vue?vue&type=style&index=0&id=2c4c695a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c695a",
  null
  
)

export default component.exports